import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ActivityService {
    constructor(private http: HttpClient){
        
    }

    getById(id: string){
        return this.http.get(`${environment.baseUrl}/activities/${id}`) || '';
    }

    getByField(data: any){
        return this.http.post(`${environment.baseUrl}/activities/search`, data)
    }

    createActivity(activity: any){
        return this.http.post(`${environment.baseUrl}/activities/create`,activity);
    }

    updateActivity(activity: any){
        return this.http.post(`${environment.baseUrl}/activities/update`,activity);
    }

}